import React from 'react';
import { FaTimes, FaVideo, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { CCTVCamera } from '../utils/cctvTypes';
import { formatTimestamp } from '../utils/cctvApiService';

interface CCTVCameraModalProps {
  camera: CCTVCamera;
  onClose: () => void;
}

const CCTVCameraModal: React.FC<CCTVCameraModalProps> = ({ camera, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">
            <FaVideo className="title-icon" />
            <h2>{camera.name}</h2>
          </div>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="status-section">
            <span className={`status-badge large ${camera.status}`}>
              {camera.status === 'active' ? 'Working' : 'Non-Working'}
            </span>
          </div>

          <div className="info-section">
            <h3><FaMapMarkerAlt /> Location</h3>
            <div className="info-grid">
              <div className="info-item">
                <label>Station</label>
                <span>{camera.station}</span>
              </div>
              <div className="info-item">
                <label>Zone</label>
                <span>{camera.zone}</span>
              </div>
              <div className="info-item">
                <label>Division</label>
                <span>{camera.division}</span>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h3><FaClock /> Activity</h3>
            <div className="info-grid">
              <div className="info-item">
                <label>Last Updated</label>
                <span>{formatTimestamp(camera.lastActivity)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CCTVCameraModal;
